module.exports = {
  illustrationItems: [
    {
      number: 588,
      image: '/images/Internship-providers.gif',
      title: {
        zh: '機構提供實習機會',
        en: 'Internship providers',
      },
      text: {
        zh: '旅遊學院致力與全球的旅遊及酒店業機構保持緊密聯繫，為學生提供寶貴的實習機會。',
        en: 'Strong connections between IFT and hotel and hospitality enterprises around the world provide IFTs students ample opportunities for quality internships',
      },
    },
    {
      number: 11853,
      image: '/images/International-qualification-professional.gif',
      title: {
        zh: '職業技能認可人數',
        en: 'MORS',
      },
      text: {
        zh: '自2001年推行澳門職業技能認可基準以來，成功通過考核的總人數',
        en: 'Number of people certified by MORS since its introduction in 2001',
      },
    },
    {
      number: 439,
      image: '/images/Scholarships-available-each-year.gif',
      title: {
        zh: '每年獲頒發獎學金人數',
        en: 'Scholarships available each year',
      },
      text: {
        zh: '有賴各業界機構及社會人士的鼎力支持，學院目前與25個機構及社會人士建立獎學金計劃。',
        en: 'Firm support by the government, industry and the community has allowed IFT to establish 25 partnerships that award scholarships',
      },
    },
    {
      number: 376,
      image: '/images/Number-of-graduates.gif',
      title: {
        zh: '畢業生人數',
        en: 'Number of graduates',
      },
      text: {
        zh: '2017/18學年學士學位課程畢業生人數',
        en: 'Candidates were awarded bachelor’s degrees in 2017/18',
      },
    },
  ],
  listItems: [
    {
      title: {
        zh: '學院成就',
        en: 'International Achievements',
      },
      content: {
        zh: [
          '2003年，旅遊學院應“聯合國教科文組織”（UNESCO）及“國際文化財產保護及修復研究中心”（ICCROM）的邀請，成為“亞洲文化遺產管理學會”的創會會員，積極推動及加強區內文化遺產管理的專業培訓。2008年獲澳門特區政府頒發“旅遊功績勳章”，肯定了學院在推動本地旅遊業發展上所作出的貢獻。',
        ],
        en: [
          'In the past year, IFT received numerous awards and was widely recognised by various international bodies. In 2003, IFT was invited by United Nations Educational, Scientific and Cultural Organization (UNESCO) and the International Centre for the Study of the Preservation and Restoration of Cultural Property (ICCROM) to be one of the founding members of the Asian Academy for Heritage Management (AAHM), with the aim to promote and strengthen the heritage management in the Asia-Pacific region.',
        ],
      },
      color: 'blue',
    },
    {
      title: {
        zh: '國際評級',
        en: 'International Recognition',
      },
      content: {
        zh: [
          '作為亞太區專門提供旅遊服務業相關學位課程的高等院校之一，自2017年QS世界大學排名榜新增款待及休閒管理學科起，旅遊學院晉身全球50強，至今仍在不斷提升教學質量，在追求更高國際評級的路上繼續前行。',
          '旅遊學院亦是全球首間通過英國高等教育質素保證機構（QAA）國際質素評鑑（IQR）的高等教育機構，再次彰顯了學院優良的教學品質。 ',
        ],
        en: [
          'As one of the world-leading higher education institutes providing degree programmes in the area of tourism and hospitality, IFT was highly ranked by QS, when the QS World University Rankings in the subject area of Hospitality and Leisure Management was launched in 2017. IFT never stops improving teaching quality and continues moving forward on the way of pursuing even higher international ranking.',
          'IFT is also the world’s first higher education institute to pass the International Quality Review (IQR) from UK’s quality assurance agency for higher education - QAA - which ensures the high quality of programmes offered.',
        ],
      },
      color: 'orange',
    },
    {
      title: {
        zh: '國際學術交流',
        en: 'Worldwide Exchange',
      },
      content: {
        zh: [
          "旅遊學院具備高度的國際視野，重視從教學中加強學術交流，為學位課程學生構建一個國際化的學習環境，提高學生畢業後在職場上的競爭力。在2017/18 學年，旅遊學院與各地院校簽署合作協議和成為學術研究的夥伴院校，包括中國內地、法國、馬來西亞、緬甸、葡萄牙及香港特別行政區。",
          "旅遊學院的學生亦有機會與非本地學生一同學習，於2017/18學年有來自美洲、歐洲、非洲和亞洲的交換生來澳學習，同樣地，亦有學生到世界各地參與交換生課程。",
        ],
        en: [
          "IFT strives to develop curriculum and conduct researches with an international spirit and create an all-embracing learning environment for students to equip them for a better future. In academic year 2017/18, IFT signed new cooperation agreements and invited new research partners from all across the world, including Mainland China, France, Malaysia, Myanmar, Portugal and Hong Kong SAR.",
          "Students also have the opportunities to learn with non-local students in IFT. In academic year 2017/18, the interflow programme invited exchange students from America, Europe, Africa and other parts of Asia to Macao, while local IFT students go to different corners of the world.",
        ],
      },
      color: 'blue',
    },
    {
      title: {
        zh: '粵港澳大灣區旅遊教育培訓基地',
        en: 'The Greater Bay Area Cooperation',
      },
      content: {
        zh: [
          '2017年，國家發展和改革委員會、廣東省人民政府、香港特別行政區政府和澳門特別行政區政府簽署《深化粵港澳合作推進大灣區建設框架協議》，協議中提及支持澳門發展成為粵港澳大灣區的旅遊教育培訓基地，並發揮着獨特的作用。在2017/18學年，學院積極與本地高等教育機構及相關政府部門合作，打造澳門成為粵港澳大灣區旅遊教育培訓基地工作組。工作組的目標是建立區域旅遊研究平台，增加學生在旅遊領域升學的流動性，並提供培訓，加強學生和教師之間的溝通，以及建立更廣泛的交流平台。',
        ],
        en: [
          'In 2017, the National Development and Reform Commission (NDRC), the governments of Guangdong, Hong Kong SAR and Macao SAR signed the “Framework Agreement on Deepening Guangdong-Hong Kong-Macao Cooperation in the Development of the Bay Area” which recognises Macao’s unique position as a training centre for tourism talents in the Greater Bay Area. In academic year 2017/18, IFT cooperated with all local higher education institutions and relevant government departments to form a Working Group for the Development of Macao into Greater Bay Area’s Tourism Education and Training Base. The objective of the Group is to build a regional tourism research platform, increase the mobility of students in further education in the area of tourism, provide training, enhance exchange among students and faculty, as well as establish a broader platform for communication.',
        ],
      },
      color: 'orange',
    },
    {
      title: {
        zh: '區域人才培訓中心',
        en: 'Regional Talented Training Centre',
      },
      content: {
        zh: [
          '旅遊學院力求以優質的教學水平得到國際的認可及肯定，不少走出校門的優秀畢業生成為連接中國與世界的紐帶。學院制定的澳門職業技能認可基準（MORS），現時已經得到越來越多國內外業界及教育機構的認可及引用。在2017/18學年，1,115名業內專業人士參加了學院培訓課程，並獲得了MORS的認證，而旅業及酒店業學校亦於2017/18學年為區內提供了932個課程，並培訓了19,583人次。此外，學院積極加強與旅遊、服務和餐飲領域的國際組織合作，希望成為培養澳門本地和國際專業人才的搖籃。',
        ],
        en: [
          'IFT also pays a lot of attention in international connection and nurtures students as the bridge of connecting China and the world. Our highly acclaimed programmes and Macao Occupational Skills Recognition System (MORS) now attracted more and more professionals in the industry and learners from Mainland China and around the world to join. In academic year 2017/18, 1,115 professionals participated in the training programmes and were certified by the MORS. Through working together with international organisations in the field of tourism, services, and F&B, IFT fosters Macao as a seedbed for talents and professionals locally and internationally.',
        ],
      },
      color: 'blue',
    },
  ]
}
